import { ActivitySpinnerSize, ActivitySpinnerWidget } from '@tableau/widgets';
import React from 'react';

export function LoadingPoolsSpinner() {
  return (
    <tbody>
      <tr>
        <td colSpan={9}>
          <div className={'tb-data-grid-cell-text tb-data-grid-DataConnect-center'}>
            <ActivitySpinnerWidget
              spinnerSize={ActivitySpinnerSize.Small}
              testId={'DataConnect-pools-loading-spinner'}
            />
          </div>
        </td>
      </tr>
    </tbody>);
}
